import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import '../../index.css';
import Title from '../../components/Title';

function Complete({ history }) {
  window.sessionStorage.clear();

  return (
    <div>
      <Title title="가입완료" />
      <div
        style={{
          paddingTop: 200,
          paddingBottom: 200,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <img
          src="/icons/ic-smile.png"
          style={{ width: 78, height: 78, alignSelf: 'center' }}
        />
        <p style={{ alignSelf: 'center' }}>가입이 완료되었습니다.</p>
      </div>
      <div
        className="footer-div"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'flex-end',
        }}
      >
        <button
          className="rounded-button-y"
          onClick={() => {
            history.push('/');
          }}
          style={{}}
        >
          완료
        </button>
      </div>
    </div>
  );
}

export default withRouter(Complete);
